<template>
  <div class="roomSearchBox">
    <div class="checkCondition" v-loading="roomLoading">
      <!-- 房间选择界面 -->
      <div class="checkConditionBox address">
        <p class="title"><span>房间</span><span style="margin-right:10px">{{checkedRoom.length+'/'+rooms.length}}</span></p>
        <div class="checkList">
          <div class="searchBox">
            <el-input class="searchInput" :disabled="isEdit" v-model="room_name" style="width: 300px;margin-right:10px " placeholder="房间号关键字"></el-input>
            <el-button class="trueBtn" type="primary" v-if="!isEdit" @click="searchRoomList">搜索</el-button>
            <el-button class="cancelBtn" @click="recetRoomList" v-if="!isEdit">重置</el-button>
          </div>
          <div style="margin: 10px 0"></div>
          <el-checkbox :disabled="isEdit" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedRoom" @change="checkedRoomChange">
            <div class="checkBoxShow">
              <template v-for="room in leftShowRoom">
                <el-checkbox :disabled="isEdit||(showCurrent&&currentCheckList.includes(room))" :label="room" :key="room">
                  <span> {{ room }}</span>
                </el-checkbox>
              </template>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <!-- 房间选择界面 -->
    </div>
    <!-- 已选房间 -->
    <div class="showCondition" v-loading="roomLoading">
      <div class="checkConditionBox">
        <p class="title"><span>已选房间</span>
          <span>
            <span style="margin-right:10px;font-size:12px">{{showRoomList.rooms.length+'间'}}</span>
            <span class="clearAll" v-if="!isEdit" @click="clearCurrentCheck">清空</span>
          </span>
        </p>
        <div class="searchBox" style="padding :10px">

          <el-input class="searchInput" v-model="check_room_name" style="width:  300px;margin-right:10px " placeholder="房间号关键字"></el-input>
          <!-- v-if="!isEdit"7 -->
          <el-button class="trueBtn" type="primary" @click="checkSearch">搜索</el-button>
          <el-button class="cancelBtn" @click="recetcheckList">重置</el-button>
        </div>
        <div class="contentShow">
          <div>
            <span style=" position: relative" class="checkCard" v-for="item in showRoomList.showrooms" :key="item">
              <span> {{ item }}</span>
              <i class="el-icon-close" v-if="!(isEdit||(showCurrent&&currentCheckList.includes(item)))" @click="delCheckRoom(item)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 已选房间 -->
  </div>
</template>

<script>
import { getRoomByHotelContract } from "../hotelGroupApi";
export default {
  props: {
    hotel_contract: {
      type: String,
      default: "",
    },
    delRoomList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    delRoomList: {
      handler: function (newVal) {
        this.delRoomList = newVal;
        this.clearAll();
        if (this.hotel_contract) {
          this.getRoomList();
        }
      },
      deep: true,
      immediate: true,
    },
    hotel_contract: {
      handler: function (newVal) {
        this.hotel_contract = newVal;
        if (!this.editPage) {
          this.clearAll();
          if (this.hotel_contract) {
            this.getRoomList();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isEdit: false,
      editPage: false,
      checkAll: false,
      isIndeterminate: true,
      provinceList: [],
      cityList: [],
      province: null,
      city: null,
      room_id: "",
      room_name: "",
      checkedRoom: [],
      checkedRoomAll: [],
      rooms: [],
      checkRoomList: [],
      showRoomList: {
        rooms: [],
        roomsId: [],
        showrooms: [],
      },
      roomLoading: false,
      leftShowRoom: [],
      token: "",
      check_room_name: "",
      template_id: "",
      currentCheckList: "",
      showCurrent: false,
    };
  },
  methods: {
    checkSearch() {
      this.showRoomList.showrooms = this.showRoomList.rooms.filter((i) => {
        if (i.indexOf(this.check_room_name) != -1) {
          return i;
        }
      });
    },
    recetcheckList() {
      this.check_room_name = "";
      this.showRoomList.showrooms = [...this.showRoomList.rooms];
    },
    clearCurrentCheck() {
        this.checkAll = false;
      console.log(
        48484,
        this.currentCheckList,
        this.checkedRoom,
        this.checkRoomList
      );
      this.checkedRoom = this.checkedRoom.filter((i) => {
        if (this.currentCheckList.includes(i)) {
          return i;
        }
      });
      this.showRoomList.rooms = this.showRoomList.rooms.filter((i) => {
        if (this.currentCheckList.includes(i)) {
          return i;
        }
      });
      this.showRoomList.roomsId = this.showRoomList.rooms.map((i) => {
        return i;
      });
      this.checkRoomList = this.checkRoomList.map((i) => {
        if (this.currentCheckList.includes(i)) {
          return i;
        }
      });
      this.showRoomList.showrooms = [...this.showRoomList.rooms];
    },
    // 清空
    clearAll() {
      this.checkedRoom = [];
      this.rooms = [];
      this.checkAll = false;
      this.currentCheckList = [];
      this.showCurrent = false;
      this.showRoomList = {
        rooms: [],
        roomsId: [],
        showrooms: [],
      };
    },
    // 数据回显写入
    intData(data, hotel_contract) {
      this.showRoomList.rooms = data;
      this.showRoomList.roomsId = data.map((i) => {
        return i;
      });
      this.currentCheckList = data;
      this.showRoomList.showrooms = data;
      this.checkRoomList = this.showRoomList.rooms;
      this.checkedRoom = this.showRoomList.roomsId;
      this.roomLoading = false;
      this.getRoomList(hotel_contract);
    },

    // 已选房间删除
    delCheckRoom(item) {
      this.showRoomList.rooms = this.showRoomList.rooms.filter((i) => {
        if (i != item) {
          return i;
        } else {
          this.checkRoomList = this.checkRoomList.filter((i) => {
            if (i != item) {
              return i;
            }
          });
        }
      });
      this.showRoomList.roomsId = this.showRoomList.rooms.map((i) => {
        return i;
      });
      this.checkedRoom = this.checkRoomList.map((i) => {
        return i;
      });
      this.showRoomList.showrooms = [...this.showRoomList.rooms];
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkedRoomAll.forEach((i) => {
          if (this.checkedRoom.indexOf(i) == -1) {
            this.checkedRoom.push(i);
          }
        });
      } else {
        if (this.showCurrent) {
          this.checkedRoom = this.checkedRoom.filter((i) => {
            if (this.checkedRoomAll.indexOf(i) == -1) {
              return i;
            }
          });
          this.checkedRoom = this.currentCheckList.map((i) => {
            return i;
          });
        } else {
          this.checkedRoom = this.checkedRoom.filter((i) => {
            if (this.checkedRoomAll.indexOf(i) == -1) {
              return i;
            }
          });
        }
      }
      this.checkRoomList = this.rooms.filter((i) => {
        if (this.checkedRoom.includes(i)) {
          return i;
        }
      });
      let list = this.rooms.map((i) => {
        return i;
      });
      var arr1 = this.showRoomList.rooms.filter((i) => {
        if (list.indexOf(i) == -1) {
          return i;
        }
      });
      let arr = this.checkRoomList;
      this.showRoomList.rooms = [...arr1, ...arr];
      this.showRoomList.roomsId = this.showRoomList.rooms.map((i) => {
        return i;
      });
      this.showRoomList.showrooms = [...this.showRoomList.rooms];
      this.isIndeterminate = false;
    },
    //  房间选择
    checkedRoomChange(value) {
      let checklist = this.checkedRoom.filter((i) => {
        if (this.checkedRoomAll.indexOf(i) != -1) {
          return i;
        }
      });
      if (checklist.length == this.checkedRoomAll.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.checkRoomList = [];
      this.checkRoomList = this.rooms.filter((i) => {
        if (this.checkedRoom.includes(i)) {
          return i;
        }
      });
      let list = this.rooms.map((i) => {
        return i;
      });
      var arr1 = this.showRoomList.rooms.filter((i) => {
        if (list.indexOf(i) == -1) {
          return i;
        }
      });
      let arr = this.checkRoomList;
      this.showRoomList.rooms = [...arr1, ...arr];
      this.showRoomList.roomsId = this.showRoomList.rooms.map((i) => {
        return i;
      });
      this.showRoomList.showrooms = [...this.showRoomList.rooms];
      //   this.showRoomList.rooms.
    },
    // 重置房间列表
    recetRoomList() {
      this.room_name = "";
      this.leftShowRoom = this.rooms.map((i) => {
        return i;
      });
    },
    // 重置房间列表
    searchRoomList() {
      this.leftShowRoom = this.rooms.filter((i) => {
        if (i.includes(this.room_name)) {
          return i;
        }
      });
      console.log(this.leftShowRoom);
    },
    // 获取房间列表
    getRoomList(hotel_contract) {
      this.roomLoading = true;
      var params = {
        hotel_contract: hotel_contract ? hotel_contract : this.hotel_contract,
      };
      getRoomByHotelContract(params).then((res) => {
        if (res.data.code === 100000 && res.data.data) {
          var tableData = res.data.data;
          if (this.delRoomList.length > 0) {
            tableData = [...this.delRoomList];
          }
          this.rooms = tableData;
          this.leftShowRoom = tableData;
          if (this.rooms.length > 0) {
            this.checkedRoomAll = this.rooms.map((i) => {
              return i;
            });
            let checklist = this.checkedRoom.filter((i) => {
              if (this.checkedRoomAll.indexOf(i) != -1) {
                return i;
              }
            });
            if (checklist.length == this.checkedRoomAll.length) {
              this.checkAll = true;
            } else {
              this.checkAll = false;
            }
          }

          this.roomLoading = false;
        } else {
          this.$message.warning(res.data.msg);
          this.roomLoading = false;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.roomSearchBox {
  width: 100%;
  height: 400px;

  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.checkCondition {
  width: 50%;
  height: 100%;
  border: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-start;
  margin-right: 16px;
}
.showCondition {
  width: calc(50% - 16px);
  height: 100%;
  border: 1px solid #ebeef5;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-top: 1px solid #e4e7ed !important;
  border-bottom: 1px solid #e4e7ed !important;
  border-radius: 0;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  border-left: 1px solid #e4e7ed !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
  border-right: 1px solid #e4e7ed !important;
}
.checkCondition .checkConditionBox {
  flex: 1;
}

.checkCondition .address:last-child {
  border-right: none;
}
.checkCondition .title,
.showCondition .title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ebeef5;
  background: #f7f8fa;
  color: #222;
  padding: 0 0 0 10px;
  box-sizing: border-box;
  font-size: 14px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title span:first-child {
  color: #596080;
  font-size: 16px;
}
.title span:last-child {
  color: #8a8c99;
  font-size: 12px;
}
.checkList {
  padding: 10px;
  height: 340px;
}
.checkBoxShow {
  height: 240px;
  overflow: hidden;
  overflow-y: visible;
}
.el-checkbox {
  display: block;
  height: 30px;
}
.showCondition .checkConditionBox {
  height: calc(100%);
}
.showCondition .contentShow {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  height: calc(100% - 130px);
  overflow: hidden;
  overflow-y: visible;
}
.showCondition .contentShow > div {
  width: 100%;
}
.checkType {
  margin-right: 5px;
  font-size: 14px;
}
.checkCard {
  display: inline-block;

  font-size: 12px;
  margin-right: 5px;
  margin-bottom: 5px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ebebed;
  background: #f8f9fa;
  color: #596080;
  padding: 0 20px 0 10px;
  border-radius: 3px;
}
::v-deep .el-checkbox__label {
  width: 100%;
}
::v-deep .el-checkbox:last-of-type {
  margin-right: 30px !important;
}
.openPlace {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.openPlace i {
  font-size: 14px;
  cursor: pointer;
}
.openPlace i:hover {
  color: #658bff;
}
.el-radio {
  display: block;
}
.greenBtn {
  width: 15%;
  max-width: 100px;
  background: #658bff;
  border: 1px solid #658bff;
  color: #fff;
}
.whiteBtn {
  width: 15%;
  max-width: 100px;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.el-icon-close {
  position: absolute;
  top: 50%;
  right: -2px;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.el-checkbox {
  margin-bottom: 0px;
}
.clearAll {
  border: 1px solid #ebebed;
  margin-right: 10px;
  height: 28px;
  padding: 0 10px;
  line-height: 28px;
  color: #596080 !important;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}
</style>